import { api } from "../client";
import {
  CampaignOpportunityExtraFields,
  CampaignOpportunityFields,
} from "../schema/CampaignOpportunity";
import { Config } from "../types";

type ApiRequestConfig = Config<
  CampaignOpportunityFields,
  CampaignOpportunityExtraFields
>;

export const getCampaignOpportunities = async (config?: ApiRequestConfig) => {
  return api.get<CampaignOpportunityFields, CampaignOpportunityExtraFields>(
    "campaign_opportunities",
    config
  );
};
